import React from "react";

export default function App() {
  return (
    <footer className="App-footer">
      <small>
        This project is coded by{" "}
        <a href="https://aworkconsulting.se/" target="_blank" rel="noreferrer">
          Emelie Jansson{" "}
        </a>
        , is{" "}
        <a
          href="https://github.com/aworkconsulting/emelie-dictionary"
          target="_blank"
          rel="noreferrer"
        >
          open-sourced on GitHub{" "}
        </a>
        and{" "}
        <a
          href="https://teal-sundae-398857.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          hosted on Netlify
        </a>
        🤓
      </small>
    </footer>
  );
}
